<build-section
  [title]="'cakeBuilder.checkDateSection.title' | translate">
  <div class="form-group mb-2">
    <div class="d-flex align-items-center">
      <div class="datepicker-container">
        <ui-datepicker-popup
          [(model)]="checkingDate"
          [minDate]="todayDate"
          (modelChange)="checkDate($event)"
        ></ui-datepicker-popup>
      </div>
      <div class="font-sm ps-3" *ngIf="checkInfo">
        <div class="text-danger"
             *ngIf="!checkInfo.closestDate && !checkInfo.date"
             [innerHTML]="'cakeBuilder.checkDateSection.notAvailable' | translate">
        </div>
        <div class="text-danger"
             *ngIf="checkInfo.closestDate"
             [innerHTML]="'cakeBuilder.checkDateSection.closestDate' | translate: {closestDate: checkInfo.closestDate | date: 'dd.MM.yyyy'}">
        </div>
        <div class="" *ngIf="checkInfo.date" translate>
          cakeBuilder.checkDateSection.available
          <ng-container *ngIf="!checkInfo.deliveryPointExists || !checkInfo.outletExists">
            <div class="text-danger" *ngIf="checkInfo.deliveryPointExists"
                 [innerHTML]="'cakeBuilder.checkDateSection.onlyDeliveryAvailable' | translate">
            </div>
            <div class="text-danger" *ngIf="checkInfo.outletExists"
                 [innerHTML]="'cakeBuilder.checkDateSection.onlyPickupAvailable' | translate">
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</build-section>
